export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const IMPRINT = '/imprint';
export const ABOUT = '/about';
export const DETAIL_PAGE = '/view/:id';
export const HOME = '/';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const DASHBOARD = '/dashboard';
export const PROFILE = '/profile';
export const SEARCH = '/search';
export const CONTENT = '/content';



// WEBPACK FOOTER //
// ./src/constants/routes.js